/* eslint-disable lingui/no-unlocalized-strings -- valores e rótulos pt-BR do fio (`*Display`), U02; a tela traduz pelos enums */

// Valores técnicos e rótulos do fio do Pix Med Admin, copiados do legado. Os rótulos daqui vão no fio
// (`statusDisplay`, `contestationTypeDisplay`) sempre em pt-BR; a tela usa os enums traduzidos (U33).

/** `statusOptions` (`pages/BankAccount/PixMedAdmin/constants.ts:1-8`): valor, número do `newStatus` e rótulo. */
export const STATUS_OPTIONS = [
  { value: 'IN_ANALYSIS', number: 1, label: 'Em Análise' },
  { value: 'APPROVED', number: 2, label: 'Aprovada' },
  { value: 'PARTIALLY_REFUNDED', number: 3, label: 'Valor devolvido parcialmente' },
  { value: 'FULLY_REFUNDED', number: 4, label: 'Valor devolvido integralmente' },
  { value: 'REJECTED', number: 5, label: 'Recusada' },
  { value: 'DEADLINE_EXPIRED', number: 6, label: 'Prazo encerrado' },
] as const;

export type PixMedStatus = (typeof STATUS_OPTIONS)[number]['value'];
export const STATUS_VALUES = STATUS_OPTIONS.map((option) => option.value) as [PixMedStatus, ...PixMedStatus[]];

/** O painel não oferece os dois "devolvido" (`Drawer/PixMedAdminDrawerForm.tsx:6-10`). */
export const PANEL_REMOVED_STATUSES: readonly PixMedStatus[] = ['PARTIALLY_REFUNDED', 'FULLY_REFUNDED'];
export const PANEL_STATUS_VALUES = STATUS_VALUES.filter((value) => !PANEL_REMOVED_STATUSES.includes(value)) as [
  PixMedStatus,
  ...PixMedStatus[],
];

/** `newStatus` pelo valor escolhido (`services/pixMedAdmin/pixMedAdmin.ts:32-34`); fora da lista, `undefined`. */
export function statusNumber(value: unknown): number | undefined {
  return STATUS_OPTIONS.find((option) => option.value === value)?.number;
}

export function statusWireLabel(value: unknown): string | undefined {
  return STATUS_OPTIONS.find((option) => option.value === value)?.label;
}

/** `contestationTypeOptions` (`PixMedAdminForm.tsx:19-22`). O valor vai numérico no fio. */
export const CONTESTATION_TYPE_OPTIONS = [
  { value: '1', label: 'Contestação realizada' },
  { value: '2', label: 'Contestação recebida' },
] as const;

export type PixMedContestationType = (typeof CONTESTATION_TYPE_OPTIONS)[number]['value'];

export function contestationTypeWireLabel(value: unknown): string | undefined {
  return CONTESTATION_TYPE_OPTIONS.find((option) => option.value === value)?.label;
}

/** Caminho do legado (`router.tsx:684-691`). */
export const PIX_MED_PATH = '/contas-digitais/pix-med-admin';
